import XLSX from 'xlsx'
function importToExcel(inputId,e,tableName,callback){
      var theTable = this.$refs[tableName];
      // 读取本地excel文件
      var files = e.target.files;
      if(!files) return 
      var rABS = false; //是否将文件读取为二进制字符串
      var f = files[0];
      var reader = new FileReader();
      // if(!/.(csv)$/g.test(f.name)){
      //   var reader = "\uFEFF" + reader;
      // }
      var outdata;
      try {
        FileReader.prototype.readAsBinaryString = function (f) {
          var binary = "";
          var rABS = false; //是否将文件读取为二进制字符串
          var wb; //读取完成的数据
          var reader = new FileReader();
          console.log(reader)
          reader.onload = function (e) {
            var bytes = new Uint8Array(reader.result);
            var length = bytes.byteLength;
            for (var i = 0; i < length; i++) {
              binary += String.fromCharCode(bytes[i]);
            }
            // var XLSX = require('xlsx');
            if (rABS) {
              wb = XLSX.read(btoa(fixdata(binary)), { //手动转化
                type: 'base64'
              });
            } else {
              wb = XLSX.read(binary, {
                type: 'binary'
              });
            }
            console.log(wb.Sheets[wb.SheetNames[0]])
            // outdata就是你想要的东西 excel导入的数据
            // 将返回的数据转换为json对象的数据
            outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
            //处理得到的结果
            callback(dealImportData(outdata,theTable))
          //重置input的值，防止第一次点击之后，点击无反应问题
          document.getElementById(inputId).value = "";
          }
          reader.readAsArrayBuffer(f);
        }
        if (rABS) {
          reader.readAsArrayBuffer(f);
        } else {
          reader.readAsBinaryString(f);
        }
      } catch (error) {
        alert("导入失败");
      }
      console.log(outdata)
      return outdata
  }
  //处理得到的结果
  function dealImportData(outdata,theTable){
    var columns = theTable.$options.propsData.columns
    var tHeader = {}
    columns.map(item => {
      if (item.key) {
        tHeader[item.key] = item.title
      }else {
        tHeader[item.slot] = item.title
      }
    })
    
    
    var dataList = []
    outdata.map((item,index) => {
      var obj = {}
      for(var i in item) {
        for(var j in tHeader) {
          if (i == tHeader[j]) {
            obj[j] = item[i]
          }
        }
      }
      dataList.push(obj)
    })
    // if (timeArr) {
    //   dataList.map((item) => {
    //     for(var i in item) {
    //         timeArr.forEach(item1 => {
    //           if (i == item1) {
    //             if (typeof item[i] == 'number') {
    //               item[i] = formatExcelDate(item[i],'/')
    //             }
    //           }
    //         });
    //     }
    //   })
    // }
    return dataList
}
// function formatExcelDate(numb, format) {
//   let time = new Date((numb-25567) * 24 * 3600000 - 5 * 60 * 1000 - 43 * 1000  - 24 * 3600000 - 8 * 3600000)
//   let year = time.getFullYear() + ''
//   let month = time.getMonth() + 1 + ''
//   let date = time.getDate() + ''
//   if (format && format.length === 1) {
//     return year + format + (month < 10 ? '0' + month : month) + format + (date < 10 ? '0' + date : date);
//   }
//   return year + (month < 10 ? '0' + month : month) + (date < 10 ? '0' + date : date);
// }

export default {
  importToExcel
}


// WEBPACK FOOTER //
// ./src/util/ExcelImport.js